module.exports = __webpack_public_path__ + "components/flag/static/square/ai-e7d80682edcd33791e3cb22febf3815b.svg";